import {getDictDataByDictType} from "@/api/system/dictionarydata";
import Vue from "vue";

const state = {
    // 存储不同类型的字典数据
    dictionaries: {},
    // 新增：记录正在请求中的字典类型
    pendingDicts: new Set()
};

const getters = {
    getLabel: (state) => (dictType, key) => {
        const dict = state.dictionaries[dictType];
        if (!dict || !dict[key]) {
            return null;          // 或返回 key 本身、空字符串，看业务需要
        }
        return dict[key].dictLabel ?? null;
    },
    getDict: (state) => (dictType) => {
        return state.dictionaries[dictType] || {};
    }
}

const mutations = {
    SET_DICT_DATA: (state, { dictType, data }) => {
        Vue.set(state.dictionaries, dictType, data);
        // 请求完成移除
        state.pendingDicts.delete(dictType);
    },
    SET_PENDING_DICT: (state, dictType) => {
        // 标记为请求中
        state.pendingDicts.add(dictType);
    }
}

const actions = {
    fetchDictData({ commit }, {dictType}) {
        if (state.pendingDicts.has(dictType)) { // 已在请求中
            return Promise.resolve();
        }
        commit('SET_PENDING_DICT', dictType);
        return getDictDataByDictType(dictType).then(res => {
            commit('SET_DICT_DATA', { dictType, data: res.data });
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
